import Send from "../../assets/images/send.png";
import { Footer, Navbar } from "./landingpage";

const features = [
  {
    title: "Instant activation"
  },
  {
    title: "Lowest possible Charges"
  },
  {
    title: "Secure checkout"
  },
  {
    title: "24/7 support"
  },  
]

const supportAssets = [
  {
    title: "Electricity"
  },
  {
    title: "Airtime (MTN, GLO, 9Mobile, Airtel"
  },
  {
    title: "Mobile Data bundles"
  },  
]

const BillPayment = () => {
  return (
    <div>
      <div className="sm:px-20 px-3">
      <Navbar />
      </div>
      <div className="flex justify-between sm:px-20 px-3">
        <div className="w-[50%]">
          <h3 className="text-5xl font-bold">Pay Bills Without Stress</h3>
          <p className="mt-5 p-1 font-Manrope text-lg">
            Jamestown makes everyday life easier with fast, secure bill payment services.
          </p>
        </div>

        <div className="w-[40%]">
          <img src={Send} alt="Wallet" className="rounded-lg" />
        </div>
      </div>

      <div className="sm:px-20 px-3">
        <h3>Bills You Can Pay</h3>
        {supportAssets.map((feature => (
          <div key={feature.title}>
            <h2>{feature.title}</h2>
          </div>
        )))}
      </div>

      <div className="sm:px-20 px-3">
        {features.map((feature => (
          <div key={feature.title}>
            <h2>{feature.title}</h2>
          </div>
        )))}
      </div>

      <Footer />
    </div>
  );
};

export default BillPayment;
